import { Icon } from '@tallink/components-lib'
import * as PropTypes from 'prop-types'
import React from 'react'

import s from './Hint.module.scss'
import Tooltip from './Tooltip'

export default function Hint({ title, text }) {
  return (
    <Tooltip text={text} title={title}>
      <Icon className={s.icon} size="s" type="question" />
    </Tooltip>
  )
}

Hint.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}
